import {isEqual} from 'lodash';
import React, {FC, useMemo} from 'react';

import {ClearFiltersButton} from '../../../../components/common/filters/common/clearFiltersButton';
import {useAppDispatch, useAppSelector} from '../../../../helpers/reduxHelpers';
import {InterfaceEventsEnum} from '../../../../services/tracking';
import {updateFiltersAction} from '../../../../store/panels/analytics/filters/analyticsPanelFiltersActions';
import {getAnalyticsFilters} from '../../../../store/panels/analytics/filters/analyticsPanelFiltersSelectors';
import {DEFAULT_FILTERS_STATE} from '../../../../store/panels/analytics/filters/analyticsPanelFiltersState';
import {getAnalyticsSelectedViewId} from '../../../../store/panels/analytics/parameters/analyticsPanelParametersSelectors';
import {makeGetSelectedView} from '../../../../store/panels/analytics/views/analyticsPanelViewsSelectors';
import {isAnalyticsViewSaved} from '../../../../store/panels/analytics/views/analyticsPanelViewsState';
import {isFilterValueNotEmpty, mapTermsToFilters} from '../../../helpers/analyticsSavedViewsHelpers';
import {useAnalyticsTracking} from '../../../helpers/tracking/useAnalyticsTracking';

/*
 * Component.
 */

export const ReportHeaderFiltersResetButton: FC = () => {
  const dispatch = useAppDispatch();

  const trackAnalytics = useAnalyticsTracking();
  const selectedViewId = useAppSelector(getAnalyticsSelectedViewId);
  const filters = useAppSelector(getAnalyticsFilters);
  const selectedView = useAppSelector(makeGetSelectedView(selectedViewId));

  const originalFilters = useMemo(
    () => (!selectedView ? DEFAULT_FILTERS_STATE : mapTermsToFilters(selectedView.filters)),
    [selectedView],
  );

  const resetFiltersCallback = () => {
    trackAnalytics(InterfaceEventsEnum.ANALYTICS_RESET_FILTER_CLICK);
    dispatch(updateFiltersAction(originalFilters));
  };

  // Display the reset button only if the current filters deviate from
  // originalFilters (on a saved view) or when a filter is applied (on ALL_DATA and tmp views).
  const shouldDisplayReset = isAnalyticsViewSaved(selectedViewId)
    ? !isEqual(originalFilters, filters)
    : Object.values(filters).some(isFilterValueNotEmpty);

  if (!shouldDisplayReset) {
    return null;
  }

  return <ClearFiltersButton onClick={resetFiltersCallback} />;
};
